/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListEvaluationRunsPathParams = NonNullable<operations['listEvaluationRuns']['parameters']['path']>;

export type ListEvaluationRunsQueryParams = NonNullable<operations['listEvaluationRuns']['parameters']['query']>;

export interface Input extends ListEvaluationRunsPathParams {
  apiVersion?: string;
  query?: ListEvaluationRunsQueryParams;
}

export async function listEvaluationRuns(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/evaluations/{evaluationId}/runs', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
